import { render, staticRenderFns } from "./wx-video.vue?vue&type=template&id=37f760dc&scoped=true&"
import script from "./wx-video.vue?vue&type=script&lang=js&"
export * from "./wx-video.vue?vue&type=script&lang=js&"
import style0 from "./wx-video.vue?vue&type=style&index=0&id=37f760dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f760dc",
  null
  
)

export default component.exports